import { Component, Input, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'app-splash-screen',
  templateUrl: './splash-screen.component.html',
  styleUrls: ['./splash-screen.component.scss'],
  standalone: false,
})
export class SplashScreenComponent implements OnInit, OnDestroy {
  @Input()
  loadingTime = 5000;

  @Input()
  progressIncrementInterval = 100;

  @Input()
  currentProgress = 0;

  private interval: any;

  constructor() {
  }

  ngOnInit(): void {
    this.interval = setInterval(() => {
      this.currentProgress += 100 / (this.loadingTime / this.progressIncrementInterval);
    }, this.progressIncrementInterval);
  }

  ngOnDestroy() {
    clearInterval(this.interval);
  }
}
